<template>
  <div>
    <template v-if="isPersonalized">
      <!-- <FormulateInput
        v-if="layer.type === 'Text'"
        :name="layer.id"
        :label="layer.personalized.title || layer.title"
        :help="layer.personalized.help"
        :placeholder="layer.personalized.placeholder"
        input-class="form-control"
        :validation="validation(layer)"
      /> -->
      <text-field
        v-if="layer.type === 'Text'"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
      />
      <image-field
        v-if="layer.type === 'Image' &&
              !layer.imageLyric &&
              !layer.imageMap &&
              !layer.imageShape &&
              !layer.imageStarMap &&
              !layer.imageCutFace &&
              !layer.imageRemoveBackground &&
              !layer.imageScrabble &&
              !layer.imageCalendarPicker &&
              !layer.imageToy3d &&
              !layer.imageqrcode &&
              !layer.imageHandWriting &&
              !layer.imageMoonPhase"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
      />
      <option-field
        v-if="layer.type === 'Option' && layer.options.length > 0"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
      />
      <lyrics-field
        v-if="layer.type === 'Image' && layer.imageLyric"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
        @ChangeTextSongLyric="ChangeTextSongLyric"
      />

      <map-field
        v-if="layer.type === 'Image' && layer.imageMap"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
        @ChangeTextMapChild='ChangeTextMapChild'
      />
      <image-shape-field
        v-if="layer.type === 'Image' && layer.imageShape && !type_shape_number"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
      />

      <image-cut-face-field
        v-if="layer.type === 'Image' && layer.imageCutFace"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
      />

      <image-shape-multiple-field
        v-if="layer.type === 'Image' && layer.imageShape && type_shape_number"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
      />

      <ImageStarMapField
        v-if="layer.type === 'Image' && layer.imageStarMap"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
        @ChangeApplySky="ChangeApplySky"
      />

      <ImageRemoveBackgroundField
        v-if="layer.type === 'Image' && layer.imageRemoveBackground"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
      />
      <ImageScrabbleField
        v-if="layer.type === 'Image' && layer.imageScrabble"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
      />
      <ImageCalendarPickerField
        v-if="layer.type === 'Image' && layer.imageCalendarPicker"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
      />
      <ImageToy3dField
        v-if="layer.type === 'Image' && layer.imageToy3d"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
      />
      <ImageQRField
        v-if="layer.type === 'Image' && layer.imageqrcode"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
      />
      <ImageHandWritingField
        v-if="layer.type === 'Image' && layer.imageHandWriting"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
      />
      <ImageMoonPhaseField
        v-if="layer.type === 'Image' && layer.imageMoonPhase"
        :layer="layer"
        :artwork="artwork"
        :personalized="personalized"
        :name="layer.id"
        @changeTextMoonPhase="ChangeTextMoonPhase"
      />
    </template>
    <group-field
      v-if="layer.type === 'Group'"
      :layer="layer"
      :artwork="artwork"
      :personalized="personalized"
      @ChangeGroupApplySky="ChangeGroupApplySky"
      @ChangeTextMapChild="ChangeTextMapChild"
      @ChangeTextSongLyric="ChangeTextSongLyric"
      @changeTextMoonPhase="ChangeTextMoonPhase"
    />
    <label-field
      v-if="layer.type === 'Label' "
      :layer="layer"
      :artwork="artwork"
      :personalized="personalized"
      :name="layer.id"
    />

  </div>
</template>
<script>
import GroupField from './GroupField.vue'
import ImageField from './ImageField.vue'
import TextField from './TextField.vue'
import OptionField from './OptionField.vue'
import LyricsField from './LyricsField.vue'
import MapField from './MapField.vue'
import ImageShapeField from './ImageShapeField.vue'
import ImageStarMapField from './ImageStarMapField.vue'
import ImageShapeMultipleField from './ImageShapeMultipleField'
import ImageCutFaceField from './ImageCutFaceField'
import LabelField from "./LabelField";
import ImageRemoveBackgroundField from './ImageRemoveBackgroundField'
import ImageScrabbleField from './ImageScrabbleField.vue';
import ImageCalendarPickerField from './ImageCalendarPickerField';
import ImageToy3dField from "./ImageToy3dField"
import ImageQRField from "./ImageQRField"
import ImageHandWritingField from './ImageHandWritingField.vue'
import ImageMoonPhaseField from './ImageMoonPhaseField.vue'
import { get } from 'lodash'
import { layer } from '@fortawesome/fontawesome-svg-core'

export default {
  components: { TextField, ImageField, GroupField, OptionField, LyricsField, MapField, ImageShapeField, ImageStarMapField, ImageShapeMultipleField, LabelField, ImageCutFaceField, ImageRemoveBackgroundField, ImageScrabbleField, ImageCalendarPickerField, ImageToy3dField, ImageQRField, ImageHandWritingField, ImageMoonPhaseField },
  name: 'layer-form-item',
  props: {
    layer: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    personalized: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data(){
    return {
      type_shape_number: false
    }
  },
  created() {
    const ThisLayer = this.layer;
    if('type_shape_number' in ThisLayer){
      if(ThisLayer.type_shape_number == "multiple"){
        this.type_shape_number = true;
      }
    }
  },
  computed: {
    isPersonalized() {
      return (
        this.layer.type === 'Option' ||
        (this.layer.personalized && this.layer.personalized.enable === true)
      )
    },
    isGroup() {
      return this.layer.type === 'Group'
    },
    layers() {
      return this.layer.layers || []
    }
  },
  methods: {
    checkRule(rule) {
      const { personalized } = this
      switch (rule.logic) {
        case '=':
          return personalized[rule.option] === rule.value
        default:
          return personalized[rule.option] !== rule.value
      }
    },
    checkCondition(layer) {
      const condition = {
        ...{ enable: false, rules: [] },
        ...get(layer, 'condition', {})
      }
      if (
        !condition ||
        condition.enable === false ||
        condition.rules.lenght === 0
      ) {
        return true
      }
      var pass = false
      var checks = condition.rules.map(rule => this.checkRule(rule))
      if (condition.match === 'all') {
        pass = checks.every(result => result)
      } else if (condition.match === 'one') {
        pass = checks.some(result => result)
      } else if (condition.match === 'none') {
        pass = checks.every(result => !result)
      }
      return condition.action === 'show' ? pass : !pass
    },
    ChangeApplySky(data){
      this.$emit('ChangeApplySky', data)
    },
    ChangeGroupApplySky(data){
      this.$emit('ChangeGroupApplySky', data)
    },
    ChangeTextMapChild(v){
      this.$emit('ChangeTextMapChild', v);
    },
    ChangeTextSongLyric(v){
      this.$emit('ChangeTextSongLyric', v);
    },
    ChangeTextMoonPhase(data){
      this.$emit('changeTextMoonPhase', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/LayerFormItem.vue